export default "__VITE_ASSET__DXPwOmow__"